import React, { useState } from 'react';
import useDefaultSubscribeForm from 'hooks/useDefaultSubscribeForm';
import RevealContent from 'components/RevealContent';
import { StyledForm, SubscribeLabel } from './Style';

const SubscribeForm = ({
  dataPosition,
  formType,
  inlineMarketingForm,
  label,
  onSuccess,
  formClassNames,
  revealProps = false,
  width,
  ...otherProps
}) => {
  const [showReveal, setShowReveal] = useState(false);
  inlineMarketingForm = inlineMarketingForm || useDefaultSubscribeForm();

  const handleOnSuccess = () => {
    if (onSuccess) {
      onSuccess();
    }
    setShowReveal(false);
  };

  return (
    <>
      {label && <SubscribeLabel className="subscribe-form--label font-p">{label}</SubscribeLabel>}
      <StyledForm
        className={formClassNames}
        showReveal={setShowReveal}
        dataPosition={dataPosition}
        formType={formType}
        title=""
        inlineMarketingForm={{ ...inlineMarketingForm }}
        containerPadding="0"
        backgroundColor="transparent"
        showPrivacy={false}
        onSuccess={handleOnSuccess}
        onSubmit={handleOnSuccess}
        isEmailCapture
        {...otherProps}
      />
      {revealProps && (
        <RevealContent
          showContent={showReveal}
          content={revealProps.content}
          styles={revealProps.styles}
        />
      )}
    </>
  );
};

export default SubscribeForm;
